import React, {FC, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Button, Result} from "antd";
import {PublicShell} from "../Components/ui/PublicShell";

const NotFoundPage: FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const onBackButtonClicked = useCallback(() => {
        navigate("/");
    }, [navigate]);

    return <PublicShell>
        <Result
            status="404"
            title="404"
            subTitle={t("NotFoundPage_Title")}
            extra={<Button type="primary"
                           onClick={onBackButtonClicked}>{t("NotFoundPage_BackButton")}</Button>}
        />
    </PublicShell>;
}

export default NotFoundPage;